import { useTranslation } from 'react-i18next';
import styles from './NextTrips.module.scss';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

interface NextTripsProps {
  className?: string;
  dateTimes: any[];
  tripId: string;
}

export default function NextTrips({
  className,
  dateTimes,
  tripId,
}: NextTripsProps) {
  const { t } = useTranslation();
  const [showMoreButton, setShowMoreButton] = useState(false);

  useEffect(() => {
    if (dateTimes.length >= 5) {
      setShowMoreButton(true);
    }
  }, [dateTimes.length]);

  return (
    <span className={classNames(styles.root, className && className)}>
      {dateTimes.map((datetime: { href: string; time: string }, i: number) => (
        <a
          id={'filter_click_trip_id=' + tripId}
          key={i}
          className={classNames(
            styles.ticket,
            i > 4 && showMoreButton && styles.hidden
          )}
          href={`/${datetime.href}`}
        >
          {datetime.time}
        </a>
      ))}
      {showMoreButton && (
        <button
          className={classNames(styles.ticket)}
          onClick={() => setShowMoreButton(!showMoreButton)}
        >
          {t('more_trips')}
        </button>
      )}
    </span>
  );
}
